import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Container from "react-bootstrap/Container";
import styled from "styled-components";
import Image from "react-bootstrap/Image";
import TMDMWhite from "../images/TMDMWhite.png";
import TypeIt from "typeit-react";
import ImageContainer from "../components/ImageContainer";
import RightScrollImage from "../images/RightScrollImage.svg";
import useHorizontal from '@oberon-amsterdam/horizontal/hook';


const StyledJumbotron = styled(Jumbotron)`
  color: white;
  height: 100vh;
  margin-bottom: 0;
  align-items: center;
  text-align: left;
  position: relative;
  white-space: nowrap;
  flex: 0 0 auto;
  background: rgb(165, 171, 185);
  backgroundsize: cover;
  padding-top: 36px;
`;

const MainTitle = styled.p`
  margin: 0 auto;
  font-size: 8.3rem;
  color: rgb(255, 255, 255);
  z-index: 20;
  
  @media screen and (max-width: 425px) {
    font-size: 5rem;
    line-height: 4rem;
  }
  
`;

const MainCaption = styled.h1`
  width: 300px;
  border: 0;
  position: absolute;
  font-size: 3.3rem;
  color: #D0D0D0;
  left: 9%;
  letter-spacing: 2px;
  top: 67%;
  font-family: Lora;
  @media screen and (max-width: 425px) {
    font-size: 2rem;
  }
`;

const ClickInfo = styled.h3`
  border-top: 5px;
  border-bottom: 5px;
  border-left: 11px;
  border-right: 11px;
  border-style: solid;
  border-color: #D0D0D0;
  border-radius: 8px;
  position: absolute;
  font-family: Open Sans;
  font-size: 1rem;
  letter-spacing: 2px;
  left: 9%;
  top: 80%;
  color: #000000;
  background: #D0D0D0;
  text-transform: uppercase;
  @media screen and (max-width: 425px) {
    font-size: 0.7rem;
  }
`

const TmdLogoImageWrapper = styled(Container)`
  border: 0;
  position: fixed;
  top: 20px;
  margin-left: 0%;
  opacity: 100%;
  width: 120px;
  padding-bottom: 50px;

  
  @media screen and (max-width: 425px) {
    position: relative;
    padding:0;
    margin-left: 25%;
    margin-right: 25%;
    width: 50%;
  }
`;

const RightExpandImage = styled(Image)`
  position: absolute;
  z-index: 1;
  top: 20%;
  left: 80%;
  width: 8%;
  @media screen and (max-width: 425px) {
    left: 75%;
    width: 25%;
    top: 45%;
  }
`;

const handleSideExpandClick = () => {
  document.getElementById("landingPageContainer").scrollLeft +=
    document.documentElement.scrollWidth;
  console.log(document.documentElement.scrollWidth);
};

const MainTitleWrapper = styled(Container)`
  position: relative;
  padding: 0;
  margin: 0;
  left: 7%;
  top: 10%;
  font-family: Lora;
  
`;

const typeItOptions = {
  speed: 150,
  waitUntilVisible: true,
  cursor: false
};

const IconsLandingPage = ({ text, title, iconsContainerRef }) => {
  useHorizontal();
  document.body.style.backgroundColor = 'rgb(' + [165, 171, 185].join(',') + ')';
  if(window.innerWidth < 500){
    document.body.style.overflowY = "hidden"
  }

  return (
    <StyledJumbotron id="landingPageContainer">
      <TmdLogoImageWrapper>
        <a href="https://www.michigandaily.com/">
          <Image src={TMDMWhite} fluid />
        </a>
      </TmdLogoImageWrapper>
      <MainTitleWrapper>
        <TypeIt options={typeItOptions}>
          <MainTitle className="display-1">the</MainTitle>
          <br/>
          <MainTitle className="display-1">b-side</MainTitle>
        </TypeIt>
      </MainTitleWrapper>
      <MainCaption>{text}</MainCaption>
      <ClickInfo>Click on each icon to learn more!</ClickInfo>
      <ImageContainer refs={iconsContainerRef}></ImageContainer>
      <RightExpandImage
        src={RightScrollImage}
        onClick={handleSideExpandClick}
      />
    </StyledJumbotron>
  );
};

export default IconsLandingPage;
